import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { FocusAreasClient } from "@/features/mail/FocusAreasClient";
import { listFocusAreas, focusKeys } from "@/features/mail/focusAreas.api";
import { listUsers } from "@/features/users/users.api";

export const Route = createFileRoute("/_shell/focus-areas")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: "/mail" });
    }
  },
  component: FocusAreasScreen,
});

function FocusAreasScreen() {
  const areasQuery = useQuery({
    queryKey: focusKeys.areas,
    queryFn: () => listFocusAreas(),
  });
  // Member picker source — this screen is admin-only, so the admin-gated users
  // endpoint is available here.
  const usersQuery = useQuery({
    queryKey: ["users", { isActive: "true", forFocusPicker: true }],
    queryFn: () => listUsers({ isActive: "true" }),
  });

  return (
    <div className="wl-page" data-screen-label="Back-office Focus Areas">
      <FocusAreasClient
        areas={areasQuery.data ?? []}
        users={(usersQuery.data?.data ?? []).map((u) => ({
          id: u.id,
          displayName: u.displayName,
          email: u.email,
        }))}
        isLoading={areasQuery.isLoading}
      />
    </div>
  );
}
